/**
 * Two WHERE conditions that are one chip filter. Before multi-part filters were
 * written in parentheses, the chip wrote a JSON filter on a text column declared
 * as JSON bare — `<validity guard> AND <test>` on SQL Server, MySQL, Oracle and
 * SQLite — so the query holds it as two conditions side by side. The Visual
 * Query Editor's resolver service folds such a pair into one condition
 * (`createResolverService`'s `foldConditionPair`), so it is one pill that edits
 * and removes both.
 */

import type { DatabaseEngineId } from '../../../../core/engines/engineTypes';
import { predicateToFilterCondition } from './predicateToFilterCondition';
import { reemits } from './predicateScalarShapes';

/**
 * Whether `text` (two conditions joined by AND) parses into ONE chip condition
 * whose re-emit is `text` itself — spacing and keyword case aside.
 */
export function isChipFilterPair(text: string, engine: DatabaseEngineId): boolean {
  // Only the JSON filters on a text column are written as two conditions, and
  // every validity guard names JSON — skip the parse for anything else.
  if (!/json/i.test(text)) return false;
  const parsed = predicateToFilterCondition(text, engine);
  return parsed !== null && reemits(text, parsed, engine);
}
